import axios from 'axios'

export default {
  save(file) {
    var formData = new FormData()
    formData.append("file", file)

    let headers = {'Content-Type': 'multipart/form-data'}
    return axios.post('/files', formData, {headers})
  },
}
